import styled from "styled-components";

export const FooterWrapper = styled.div`
  width: 100%;
  background: #4a4a4a;
  text-align: center;
  color: white;
  padding: 50px 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
`;
export const FooterText = styled.p`
  margin: 8px 0;
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.95;
`;
